"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryByAbbreviation = exports.getCountry = void 0;
var countryMap_1 = __importDefault(require("./countryMap"));
function getCountry(countryName) {
    return countryMap_1.default[countryName];
}
exports.getCountry = getCountry;
function getCountryByAbbreviation(countryAbbr) {
    for (var _i = 0, _a = Object.entries(countryMap_1.default); _i < _a.length; _i++) {
        var _b = _a[_i], code = _b[0], mapping = _b[1];
        if (mapping.abbreviation === countryAbbr) {
            return code;
        }
    }
    return undefined;
}
exports.getCountryByAbbreviation = getCountryByAbbreviation;
